<template>
	<div>
		<product-detail-submenu />

		<core-layout-content large>
			<core-layout-headline-and-actions>
				<template slot="headline">
					{{ `${$t("pricing")} – ${productName}` }}
				</template>
				<template slot="actions"> </template>
			</core-layout-headline-and-actions>
			<!-- Body -->
			<j-card class="xs-12 bg5 r2 p4">
				<div class="flex xs-12 md-6 xs-left xs-top mb1">
					<h2 class="fs5 lh125 fw7 c6 mr4">
						{{ $t("pricing_rules") }}
					</h2>
				</div>
				<div class="flex wrap xs-12">
					<json-editor
						v-model="pricingRules"
						style="width:100%; height:800px;"
					/>
				</div>

				<!-- Buttons -->
				<div class="mt2">
					<j-button :isLoading="isLoading" @click="handleSave">
						{{ $t("save") }}
					</j-button>
					<j-button
						type="tertiary"
						class="ml4"
						:isDisabled="isLoading"
						@click="$router.push({ name: 'ProductsList' })"
					>
						{{ $t("cancel") }}
					</j-button>
				</div>
			</j-card>

			<j-card class="xs-12 bg5 r2 p4 mt10">
				<div class="flex xs-12 mb2">
					<h2 class="fs7 lh125 fw7 c1 mr4">{{ $t("test_pricing_rules") }}</h2>
				</div>
				<div class="flex xs-12 md-6 xs-left xs-top">
					<h2 class="fs5 lh125 fw7 c6 mr4 mb1">
						Test Data
					</h2>
				</div>
				<div class="flex xs-12">
					<json-editor
						v-model="insuredData"
						style="width:100%; height: 200px;"
					></json-editor>
				</div>
				<div class="flex xs-12 mt2 mb2">
					<pre>{{ $t("test_results") }}: {{ testResults }}</pre>
				</div>
				<!-- Buttons -->
				<div class="mt2">
					<j-button :isLoading="isLoading" @click="applyLogic">
						{{ $t("test") }}
					</j-button>
					<j-button
						type="tertiary"
						class="ml4"
						:isDisabled="isLoading"
						@click="clearResults"
					>
						{{ $t("clear") }}
					</j-button>
				</div>
			</j-card>
		</core-layout-content>
	</div>
</template>

<script>
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import ProductDetailSubmenu from "../components/ProductDetailSubmenu"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import JsonEditor from "../components/JsonEditor"
import jsonLogic from "@axa-ch/json-logic-js"

// eslint-disable-next-line no-unused-vars
import api from "../api/"

export default {
	components: {
		JCard,
		CoreLayoutHeadlineAndActions,
		JButton,
		ProductDetailSubmenu,
		CoreLayoutContent,
		JsonEditor
	},

	props: {
		plan: { type: String, required: true },
		type: { type: String, required: true },
		version: {
			validator: val => typeof val === "string" || val === null,
			required: true,
			default: null
		}
	},

	data: () => ({
		isLoading: false,
		pricingRules: "",
		insuredData: "",
		modelUri: null,
		testResults: "",
		productName: "",
		list: [],

		form: {
			rules: null
		}
	}),

	methods: {
		async getProduct() {
			const { plan, version, type } = this

			this.isLoading = true
			const res = await api.getProductPricingAndUnderwriting({
				where: { productId: { plan, version, type } }
			})
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.list = res.data.products_2.list
			if (
				this.list &&
				this.list[0] &&
				this.list[0].pricing &&
				this.list[0].pricing.amountLogic
			) {
				this.pricingRules = JSON.stringify(
					JSON.parse(this.list[0].pricing.amountLogic),
					null,
					2
				)
			}
			this.productName = this.list[0].name
		},
		async handleSave() {
			const { plan, version, type } = this

			this.isLoading = true

			const res =
				this.list[0].pricing &&
				typeof this.list[0].pricing === "object" &&
				this.list[0].pricing.amountLogic
					? await api.updatePriceLogic({
							productId: { plan, version, type },
							input: {
								amountLogic: this.pricingRules,
								currencyCode: "HKD"
							}
					  })
					: await api.createPriceLogic({
							productId: { plan, version, type },
							input: {
								amountLogic: this.pricingRules,
								currencyCode: "HKD"
							}
					  })

			this.isLoading = false

			if (res.errors) {
				// this.$store.dispatch("showError", res.errors)
				console.log("error there")
				return
			}
			return
		},
		applyLogic() {
			if (jsonLogic.is_logic(JSON.parse(this.pricingRules))) {
				this.testResults = ""
				this.testResults = jsonLogic.apply(
					JSON.parse(this.pricingRules),
					JSON.parse(this.insuredData)
				)
			} else {
				this.testResults = "Error parsing underwriting rules"
			}
		},
		clearResults() {
			this.testResults = ""
		}
	},

	created() {
		// Check if we are receiving all props
		// If not, redirect to products listing
		if (
			typeof this.plan === "undefined" ||
			typeof this.type === "undefined" ||
			typeof this.version === "undefined"
		) {
			this.$router.push({ name: "ProductsList" })
			return
		}

		// Fetch product info
		this.getProduct()
	}
}
</script>
